import DropdownIconController from "./dropdown_icon_controller";

export default class extends DropdownIconController {

  static targets = ["logout"];

  initialize() {
    super.initialize();
  }

  connect() {
    super.connect();
    this.startKeepingAlive();

    this.logoutTarget.firstElementChild.addEventListener("click", e =>
    {
      window.App.LOGGING_OUT = true;

      // let bc = new BroadcastChannel("usadealer.us");
      // bc.postMessage({ event: "logout" });
    })
  }

  disconnect() {
    super.disconnect();
    this.stopKeepingAlive();
  }

  startKeepingAlive() {
    this.keepAliveInterval = setInterval(() => {
      App.$rails.ajax({
        type: "POST",
        url: window.App.prefixedUrl(`/keep-alive`),
        data: new URLSearchParams({ after_login_url: window.location.href }).toString()
      });
    }, 5 * 60 * 1000);
  }

  stopKeepingAlive() {
    if (this.keepAliveInterval) {
      clearInterval(this.keepAliveInterval);
    }
  }
}
